import { render, staticRenderFns } from "./ToplamTedarikci.vue?vue&type=template&id=d81dcd8c&scoped=true"
import script from "./ToplamTedarikci.vue?vue&type=script&lang=js"
export * from "./ToplamTedarikci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81dcd8c",
  null
  
)

export default component.exports